<template>
    <div>
        <div class="row">
            <div class="col-lg-4" v-if="!this.hide.includes('driver')">
                <DriverSelect
                    :errors="errors ? errors : []"
                    @update-driver="updateSelectedDriver"
                />
            </div>
            <div class="col-lg-4">
                <UserSelect
                    :errors="errors ? errors : []"
                    @update-driver="updateSelectedUser"
                />
            </div>
        </div>

        <div>
            <table class="table table-bordered table-striped table-vcenter dataTable" ref="messagesDatatable" style="width: 100%;">
                <thead>
                    <tr>
                        <th v-if="!this.hide.includes('id')">ID</th>
                        <th v-if="!this.hide.includes('driver')">Driver</th>
                        <th v-if="!this.hide.includes('message')">Message</th>
                        <th v-if="!this.hide.includes('sent')">Sent</th>
                        <th v-if="!this.hide.includes('status')">Status</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { buildColumns } from "@/helpers/build-columns";
import customerSelect from '@/components/movements/components/CustomerSelect.vue';
import DriverSelect from "@/components/movements/components/DriverSelect.vue";
import UserSelect from "@/components/movements/components/UserSelect.vue";

export default {
    components: {
        DriverSelect,
        customerSelect,
        UserSelect,
    },

    props: {
        ajaxUrl: {
            type: String,
            required: true,
        },
        hide: {
            type: Array,
            default: () => [],
            required: false
        },
        sortIndex: {
            type: [Number, null],
            default: null,
            required: false
        },
        limit: {
            type: Number,
            default: 25,
            required: false
        },
        old: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            default: () => [],
            required: false
        },
    },

    data () {
        return {
            columnDefinitions: {
                id: {
                    data: 'id',
                    render: function (data, type, row) {
                        return row.computed_reference;
                    }
                },
                driver: {
                    data: 'driver.name',
                    name: 'driver_id',
                    searchable: false,
                    render: function (data, type, row) {
                        return row.computed_driver;
                    }
                },
                message: {
                    data: 'message',
                    searchable: false,
                    orderable: false,
                },
                sent: {
                    data: 'created_at',
                    searchable: false,
                    render: function (data, type, row) {
                        return row.computed_sent_by;
                    },
                    width: '20%',
                },
                status: {
                    data: 'status',
                    searchable: false,
                },
            },

            filters: {
                selectedDriver: null,
                selectedUser: null,
            },

            selectedDriver: null,
            selectedUser: null,
        }
    },

    mounted() {
        const table = window.jQuery(this.$refs.messagesDatatable).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            processing: true,
            serverSide: true,
            pageLength: this.limit,
            lengthMenu: this.computedLimits,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[this.sortIndex ?? 4, 'desc']],
            columns: buildColumns(this.columnDefinitions, this.hide),
        });

        // watch api to use table without saving it to data
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );
    },

    methods: {
        updateSelectedUser(value) {
            if (value) {
                this.selectedUser = value;
                this.filters.selectedUser = value;
            } else {
                this.selectedUser = null;
                this.filters.selectedUser = null;
            }
        },
        updateSelectedDriver(value) {
            if (value) {
                this.selectedDriver = value;
                this.filters.selectedDriver = value;
            } else {
                this.selectedDriver = null;
                this.filters.selectedDriver = null;
            }
        },
    },

    computed: {
        computedLimits() {
            const availableLimits = [25, 50, 100];

            if (this.limit && !availableLimits.includes(this.limit)) {
                availableLimits.push(this.limit);
            }

            return availableLimits.sort((a, b) => a - b);
        },
    }
};
</script>
